import React, { forwardRef } from 'react';
import GlobePairedWithText from '../text-pairing/Globe';
const Globe = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("g", { clipPath: "url(#a)", fill: "currentColor" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 22.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5Zm0 1.5c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 12C6 6.52 8.353 2.586 10.72.22l1.06 1.06C9.647 3.414 7.5 6.98 7.5 12c0 5.02 2.147 8.586 4.28 10.72l-1.06 1.06C8.353 21.413 6 17.48 6 12Zm10.5 0c0-5.02-2.147-8.586-4.28-10.72L13.28.22C15.647 2.586 18 6.52 18 12c0 5.48-2.353 9.413-4.72 11.78l-1.06-1.06c2.133-2.134 4.28-5.7 4.28-10.72Z" }),
        React.createElement("path", { d: "M1.5 7.5h21V9h-21V7.5ZM1.5 15h21v1.5h-21V15Z" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "a" },
            React.createElement("path", { fill: "currentColor", d: "M0 0h24v24H0z" }))))));
Globe.displayName = 'Globe';
// @ts-ignore;
const iconData = {
    glyph: Globe,
    group: 'basic',
    textPairingGlyph: GlobePairedWithText,
};
export default iconData;
